// Typed error taxonomy for @zebra/core. Callers (services/api) can branch on
// `instanceof` or the stable `code` string — never on message text.
export class CoreError extends Error {
    code;
    constructor(code, message) {
        super(message);
        this.name = 'CoreError';
        this.code = code;
    }
}
/** BDT and MOISTURE_BAND pricing require a moisture reading; thrown when it's missing. */
export class MissingMoistureError extends CoreError {
    constructor(message = 'Moisture content (mcPct) is required for this pricing basis') {
        super('MISSING_MOISTURE', message);
        this.name = 'MissingMoistureError';
    }
}
/** MOISTURE_BAND pricing: the reading did not fall inside any configured band. */
export class MoistureOutOfBandError extends CoreError {
    mcPct;
    constructor(mcPct, message = `Moisture reading ${mcPct}% is outside all configured bands`) {
        super('MOISTURE_OUT_OF_BAND', message);
        this.name = 'MoistureOutOfBandError';
        this.mcPct = mcPct;
    }
}
//# sourceMappingURL=errors.js.map